import React from 'react'
import ErrorCard from '../../components/ErrorCard'
import SceneLayout from '../../components/SceneLayout'

const ErrorScene = () => (
  <SceneLayout>
    <ErrorCard />
  </SceneLayout>
)

export default ErrorScene
